import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
import { Charge } from '../../read/charge';
import { Money } from '../../type/order';
import { Department } from '../department';
import { BillingGroup } from '../user-group';
/**
 * Represents an order for part of the court record.
 */
export class Order {
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], Order.prototype, "estimate", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * Human-friendly reference number for the order
     */
    )
], Order.prototype, "placedOn", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], Order.prototype, "balance", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], Order.prototype, "finalPrice", void 0);
__decorate([
    Serialize(() => ZonedDateTime),
    __metadata("design:type", Object)
], Order.prototype, "resubmittedOn", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Object)
], Order.prototype, "serviceFee", void 0);
__decorate([
    Type(() => Charge),
    __metadata("design:type", Object)
], Order.prototype, "balanceCharge", void 0);
__decorate([
    Type(() => BillingGroup),
    __metadata("design:type", Object)
], Order.prototype, "billingGroup", void 0);
__decorate([
    Type(() => Department),
    __metadata("design:type", Object)
], Order.prototype, "department", void 0);
__decorate([
    Type(() => Charge),
    __metadata("design:type", Object)
], Order.prototype, "estimateCharge", void 0);
